import { Link } from "react-router-dom";
import { PageNames } from '../Assets/variables';

const Invalid = () => {
    
    return (
        <div className="invalid-page">
            <h1>Something went wrong</h1>
            <p>The page you're trying to access does not exist</p>
            <Link to={`/${PageNames.Home}`} id="six-button-trial" className="six-button six-button--action">Go back to the Home Page</Link>
        </div>
    );
};

export default Invalid;